import React from 'react';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { FormattedText, formatText } from 'core/i18n';
import { deleteCookieAndGoHome } from 'utilities/logoutHelper';

export const BatchErrorMessages = () => {
    return (
        <div className="profesional-data-view">
            <MessagesScreen
                iconClass="icons icons--icon-clock-type-2"
                title={formatText('messagesScreen-batchErrorTitle')}
                subtitle={formatText('messagesScreen-batchErrorSubTitle')}
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={deleteCookieAndGoHome}
            >
                <FormattedText value="messagesScreen-batchErrorContent" />
                <FormattedText value="messagesScreen-batchErrorContent2" />
                <FormattedText value="messagesScreen-customerServiceDepartment" />
            </MessagesScreen>
        </div>
    );
};
